import classes from "./premium-perks.module.css";
import cx from "classnames";
import UrgentHiring from "../UrgentHiring";
import { isMobileDevice } from "../../services/utils";
import PremiumPerksMobile from "./PremiumPerksMobile";
import MiniBoostTag from "../minBoostTag";

function PremiumPerks(props) {
  const headerData = [
    {
      label: "Basic Job"
    },
    {
      label: "Premium Job"
    }
  ];

  const matchLimitData = [
    { iconSrc: "/hire/low-matches.svg", label: "Low" },
    {
      iconSrc: "/hire/high-matches.svg",
      label: "High"
    }
  ];

  const urgentHiringData = [
    {
      iconSrc: "/hire/urgent-hiring-dash.svg",
      width: 17,
      height: 17,
      label: "No"
    },
    {
      iconSrc: "/hire/urgent-hiring-check.svg",
      width: 21,
      height: 21,
      label: "Yes",
      class: classes.urgentHiringImgCls
    }
  ];

  const renderTableHeaders = () => {
    return headerData.map((header, index) => (
      <th key={index}>
        <div className={classes.premiumCont}>{header.label}</div>
      </th>
    ));
  };

  const renderMatchLimitCells = () => {
    return matchLimitData.map((cell, index) => (
      <td key={index}>
        <div className={classes.content}>
          <img
            src={cell.iconSrc}
            width={17}
            height={17}
            alt={`icon ${index}`}
            className={classes.contentIcon}
          />
          {cell.label}
        </div>
      </td>
    ));
  };

  const renderUrgentHiringCells = () => {
    return urgentHiringData.map((cell, index) => (
      <td key={index}>
        <div className={classes.content}>
          <img
            src={cell.iconSrc}
            width={cell.width}
            height={cell.height}
            alt={`icon ${index}`}
            className={cell.class}
          />
          {cell.label}
        </div>
      </td>
    ));
  };

  const tableData = [
    { label: "Increased job reach", renderCells: renderUrgentHiringCells },
    { label: "Number of direct applies", renderCells: renderMatchLimitCells },
    {
      label: "Number of database matches ",
      renderCells: renderMatchLimitCells
    },
    {
      label: "Highlighted with an urgent hiring tag",
      renderCells: renderUrgentHiringCells
    }
    // {
    //   label: "Get 1 job boost",
    //   renderCells: renderUrgentHiringCells
    // }
  ];

  const renderTableRows = () => {
    const urgentLabel = "Highlighted with an urgent hiring tag";
    const boostTag = "Get 1 job boost";
    return tableData.map((row, index) => (
      <tr key={index}>
        <td
          className={
            row.label === urgentLabel || row.label === boostTag
              ? classes.urgentHiringCont
              : classes.label
          }
        >
          <div
            className={
              row.label === urgentLabel || row.label === boostTag
                ? cx(classes.urgentHiring, classes.label)
                : classes.label
            }
          >
            {row.label}
            {row.label === urgentLabel && <UrgentHiring className="left-" />}
            {row.label === boostTag && (
              <div className="ml-2">
                <MiniBoostTag
                  tipClass={classes.tipClass}
                  toolTipUrgentHiring={classes.toolTipBoost}
                  boostContent
                />
              </div>
            )}
          </div>
        </td>
        {row.renderCells()}
      </tr>
    ));
  };

  const isMobile = isMobileDevice();
  if (isMobile) {
    return <PremiumPerksMobile />;
  }
  return (
    <>
      <div className={classes.root}>
        <div className={classes.heading}>Why post a Premium job?</div>
        {!isMobile ? (
          <div className={classes.hiringFaster}>
            <img
              src="/hire/flash.svg"
              width={13}
              height={13}
              alt={`icon flash`}
            />
            For Hiring Faster
          </div>
        ) : null}
        <table>
          <tr>
            <th>
              <div className={classes.compare}>Compare Jobs</div>
            </th>
            {renderTableHeaders()}
          </tr>
          {renderTableRows()}
        </table>
      </div>
    </>
  );
}

export default PremiumPerks;
